import { CheckIcon, CopyIcon } from 'assets/svg';
import { useEffect, useRef, useState } from 'react';

type Props = {
  value: string;
  label: string;
};

const CONFIRMATION_TIME = 1500;

function CopyButton({ value, label }: Props) {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const copy = async (event: React.MouseEvent) => {
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(value);
    } catch {
      return;
    }

    setIsCopied(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setIsCopied(false), CONFIRMATION_TIME);
  };

  return (
    <button
      type="button"
      onClick={copy}
      aria-label={isCopied ? `${label} copied` : `Copy ${label}`}
      className={`shrink-0 rounded p-0.5 transition focus-visible:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-palette-secondary ${
        isCopied
          ? 'opacity-100 text-palette-success-900'
          : // Touch devices have no hover, so the control only hides itself on the desktop layout.
            'text-palette-secondary-grey hover:text-palette-secondary lg:opacity-0 lg:group-hover:opacity-100'
      }`}
    >
      {isCopied ? <CheckIcon className="w-3.5 h-3.5" /> : <CopyIcon className="w-3.5 h-3.5" />}
    </button>
  );
}

export default CopyButton;
